export const dailyExerciseApi = {
  fetchDailyExercise: (): string =>
    `/api/portal/staff/exercises/daily-exercises`,
  updateDailyExercise: (id: string): string =>
    `/api/portal/staff/medical/exercises/daily-exercises/${id}`,
  fetchDailyPatientExercise: (): string =>
    `/api/portal/patient/exercises/daily-exercises`,
  updateDailyPatientExercise: (id: string): string =>
    `/api/portal/patient/exercises/daily-exercises/${id}`,
  createSubscriptionByPatient: (): string =>
    `/api/portal/patient/exercises/daily-exercises/subscribe`,
  fetchPatientSubscription: (id: string): string =>
    `/api/portal/patient/exercises/patient/${id}/subscription`,
  createSubscriptionByStaff: (): string =>
    `/api/portal/staff/exercises/daily-exercises/subscribe`,
  fetchPatientSubscriptionByStaff: (id: string): string =>
    `/api/portal/staff/exercises/patient/${id}/subscription`,
  fetchPatientSubscriptionPlans: (): string =>
    `/api/portal/patient/exercises/daily-exercises/subscription-plans`,
  fetchPatientSubscriptionPlansByStaff: (): string =>
    `/api/portal/staff/exercises/daily-exercises/subscription-plans`,
  processStageActionByPatient: (): string =>
    `/api/portal/patient/exercises/process-stage-action`,
  processStageActionByStaff: (): string =>
    `/api/portal/staff/exercises/process-stage-action`,
};
